/**
 * Calendar arithmetic on ISO dates (YYYY-MM-DD), timezone-free (UTC), like `previousDay`. Its
 * own module so echo's backend can use it without the rest of `content/` (`server.ts`).
 */

/** Monday of the week containing `isoDate` (YYYY-MM-DD), as an ISO date. Weeks run Mon → Sun. */
export function weekStartOf(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number) as [number, number, number];
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
  return date.toISOString().slice(0, 10);
}

export function addDays(isoDate: string, delta: number): string {
  const [year, month, day] = isoDate.split('-').map(Number) as [number, number, number];
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + delta);
  return date.toISOString().slice(0, 10);
}
